export default [
  {
    //  神在神选民经历六个试炼中见证神道成肉身与圣灵使用的人
    path: "/God-incarnate-and-man-used-by-God",
    name: "God-incarnate-and-man-used-by-God",
    component: () =>
      import(
        "@/views/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate/index.vue"
      ),
    meta: {
      title: "神在神选民经历六个试炼中见证神道成肉身与圣灵使用的人",
      order: 12,
      episode: "episode4",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/God-incarnate-and-man-used-by-God/index/front.png",
          "images/God-incarnate-and-man-used-by-God/index/God-incarnate-and-man-used-by-God-bg-preload.jpg",
        ],
      },
    },
  },
  {
    //  全能神发表话语见证神道成肉身
    path: "/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate",
    name: "testifying-to-God-incarnate",
    component: () =>
      import(
        "@/views/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate/index.vue"
      ),
    meta: {
      title: "全能神发表话语见证神道成肉身",
      order: 13,
      episode: "episode4",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate/page1ImageViewer.jpg",
        ],
      },
    },
  },
  {
    //  全能神发表话语见证圣灵使用的人
    path: "/God-incarnate-and-man-used-by-God/testifying-to-man-used-by-Holy-Spirit",
    name: "testifying-to-man-used-by-Holy-Spirit",
    component: () =>
      import(
        "@/views/God-incarnate-and-man-used-by-God/testifying-to-man-used-by-Holy-Spirit/index.vue"
      ),
    meta: {
      title: "全能神发表话语见证圣灵使用的人",
      order: 14,
      episode: "episode4",
      prefetchAssets: {
        isLoad: false,
        assets: [],
      },
    },
  },
];
